import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { HttpClient } from '@angular/common/http';
import { CommandResult, DocumentType } from '@cl/shared/models';
import { BaseFilterModel } from '@cl/shared/models/base/base-filter-model.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentTypesService extends BaseServiceWithFilter<DocumentType, BaseFilterModel> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, 'api/v1/document-types/');
    }

    getAllDocumentTypes(includeInactive: boolean = false): Observable<CommandResult<DocumentType[]>> {
        return this.httpClient.get<CommandResult<DocumentType[]>>(`${this.baseApiUrl}get-all/${includeInactive}`);
    }
}
